import { PageViewEventLogger } from '@repo/tracking-service';
import { useAtomValue } from 'jotai';
import { ReactElement, useEffect } from 'react';
import { useQueryLoader } from 'react-relay';

import { businessSameIndustryQuery } from '@/__generated__/businessSameIndustryQuery.graphql';
import Spinner from '@/components/common/Spinner';
import { SameIndustryBeforeContainer } from '@/components/survey/business/same-industry-before/SameIndustryBeforeContainer';
import { BusinessProvider } from '@/components/survey/common/BusinessProvider';
import { SurveyProvider } from '@/components/survey/common/SurveyProvider';
import { useSurveyUserEventAttributes } from '@/components/survey/common/hooks/use-survey-user-event-attributes';
import { sameIndustryQuery } from '@/graphql/query/survey/business';
import { currentBusinessBmanTinAtom, refundHistoryIdAtom } from '@/lib/stores/survey/common';

function SameIndustryBeforePage() {
  const eventAttributes = useSurveyUserEventAttributes();
  const [queryRef, loadQuery] = useQueryLoader<businessSameIndustryQuery>(sameIndustryQuery);
  const refundHistoryId = useAtomValue(refundHistoryIdAtom);
  const currentBusinessBmanTin = useAtomValue(currentBusinessBmanTinAtom);

  useEffect(() => {
    if (refundHistoryId && currentBusinessBmanTin) {
      loadQuery(
        {
          refundHistoryId,
          bmanTin: currentBusinessBmanTin
        },
        { fetchPolicy: 'network-only' }
      );
    }
  }, [currentBusinessBmanTin, loadQuery, refundHistoryId]);

  if (!queryRef) return <Spinner />;
  return (
    <PageViewEventLogger pageName={'survey_same-industry-before'} eventProperty={eventAttributes}>
      <SameIndustryBeforeContainer queryRef={queryRef} />
    </PageViewEventLogger>
  );
}

SameIndustryBeforePage.getLayout = (page: ReactElement) => (
  <SurveyProvider>
    <BusinessProvider>{page}</BusinessProvider>
  </SurveyProvider>
);

export default SameIndustryBeforePage;
